import { render, staticRenderFns } from "./PlayerShow.vue?vue&type=template&id=0fc26f90"
import script from "./PlayerShow.vue?vue&type=script&lang=js"
export * from "./PlayerShow.vue?vue&type=script&lang=js"
import style0 from "./PlayerShow.vue?vue&type=style&index=0&id=0fc26f90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports